import gql from 'graphql-tag';

import { PhotoThumbnails } from './global';

export const AccountIdentityName = gql`
  fragment AccountIdentityName on Identity {
    account_identity_name {
      id
      name
      last_name
    }
  }
`;

export const IdentityDetails = gql`
  fragment IdentityDetails on Identity {
    id
    relationship
    name
    last_name
    has_outdated_selfie
    gender
    current_photo {
      ...PhotoThumbnails
      created_at
    }
    current_matching_photo {
      ...PhotoThumbnails
    }
    ...AccountIdentityName
  }
  ${PhotoThumbnails}
  ${AccountIdentityName}
`;
